import React from 'react';

import Alert from '@mui/material/Alert';
import { useFormContext } from 'react-hook-form';

import { FormProps } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';
import classes from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal.module.scss';

interface Props {
    partialSuccess: string[];
}

export const PartialContent = ({ partialSuccess }: Props) => {
    const form = useFormContext<FormProps>();

    const file = form.watch('file');

    return (
        <>
            <div className={classes.fileName}>File: {file?.name}</div>
            <Alert severity={'warning'} className={classes.errorMessage}>
                {partialSuccess.map((item) => (
                    <div>{item}</div>
                ))}
            </Alert>
        </>
    );
};
